'use strict';

var ChartFbcLegendLegendDirective = function ChartFbcLegendLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-fbc-applicability-legend.html'),
    controller: 'ChartFbcApplicabilityLegendController',
    scope: {
      clazzes: '=',
      from: '=',
      to: '='
    },
    link: function link($scope) {
      $scope.$watchGroup(['from', 'to'], function (newValues) {
        $scope.updateTimePeriod(newValues[0], newValues[1]);
      });
    }
  };
};
ChartFbcLegendLegendDirective.$inject = [];
module.exports = ChartFbcLegendLegendDirective;